import React from 'react';
import { get } from 'lodash';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { SAVED_DASHBOARD_PATHS } from '@utils/constants';
import { getBaseUrlByProduct } from '../utils';

export const StyledLink = styled(Link)`
  color: #0046ff;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

interface IDashboardType {
  name: string;
  id: number;
}
interface IProps {
  id: number;
  name: string;
  productName: string;
  dashboardType: IDashboardType;
}

const NameLink = ({ id, name, productName = 'ei', dashboardType }: IProps) => {
  const urlPrefix = getBaseUrlByProduct(productName);
  const nameInUrl = get(SAVED_DASHBOARD_PATHS, [dashboardType.name], '');

  const url = nameInUrl ? `${urlPrefix}/dashboard/${nameInUrl}/${id}` : '';
  if (url) {
    return <StyledLink to={`${url}`}>{name}</StyledLink>;
  }
  // TODO: when would this happen? and why
  return <>{name}</>;
};

export default NameLink;
